import React from 'react';

export default function LoadingSpinner({ texto = 'Carregando...' }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5" style={{ color: 'var(--sf-text-muted)' }}>
      <div className="spinner-border mb-2" style={{ color: 'var(--sf-primary)' }} role="status" />
      <span>{texto}</span>
    </div>
  );
}
